import moment from 'moment';

export const setupMarketCommentaries = (
  marketCommentaries: any,
  appendOld = false
) => {
  const quarters: string[] = [];

  for (let i = 0; i < 4; i++) {
    const date = moment().subtract(i, 'quarters');
    const quarter = date.quarter();
    const year = date.year();
    quarters.push(`Q${quarter} ${year}`);
  }

  return [
    ...quarters.map((quarter: string) => {
      return (
        marketCommentaries.find(
          (marketCommentary: any) => marketCommentary.name === quarter
        ) || { name: quarter, content: '' }
      );
    }),
    ...(appendOld
      ? marketCommentaries.filter((marketCommentary: any) =>
          quarters.every((quarter: string) => marketCommentary.name !== quarter)
        )
      : [])
  ].sort((a: any, b: any) => {
    const [aQuarter, aYear] = a.name.split(' ');
    const [bQuarter, bYear] = b.name.split(' ');

    const aQuarterNum = parseInt(aQuarter.slice(1), 10);
    const bQuarterNum = parseInt(bQuarter.slice(1), 10);

    const aDate = new Date(aYear, (aQuarterNum - 1) * 3);
    const bDate = new Date(bYear, (bQuarterNum - 1) * 3);

    return bDate.getTime() - aDate.getTime();
  }) as any;
};

export const sortPlatforms = (platforms: any) => {
  return platforms.sort((a: any, b: any) => a.name.localeCompare(b.name));
};
